.wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 60px 24px 80px;
  background: var(--white);
  border: var(--b);
  border-radius: var(--r-lg);
  gap: 14px;
}

.iconBox {
  width: 64px;
  height: 64px;
  border-radius: var(--r-md);
  background: var(--cream);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ink-soft);
  margin-bottom: 4px;
}

.title {
  margin: 0;
  font-family: var(--sans);
  font-weight: 900;
  font-size: 20px;
  letter-spacing: -0.5px;
  color: var(--ink);
}

.sub {
  margin: 0;
  max-width: 360px;
  font-family: var(--sans);
  font-weight: 500;
  font-size: 14px;
  color: var(--mute);
  line-height: 1.5;
}

.codeBox {
  margin-top: 16px;
  background: var(--ink);
  color: var(--white);
  border-radius: var(--r-md);
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  min-width: 240px;
}

.codeLabel {
  font-family: var(--sans);
  font-weight: 900;
  font-size: 9.5px;
  letter-spacing: 1.6px;
  color: var(--orange);
  text-transform: uppercase;
}

.codeValue {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: var(--mono);
  font-weight: 900;
  font-size: 22px;
  letter-spacing: 3px;
  color: var(--white);
}

.copyBtn {
  width: 28px;
  height: 28px;
  border-radius: var(--r-sm);
  border: 1.5px solid rgba(255, 255, 255, 0.3);
  background: transparent;
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.copyBtn:hover { background: rgba(255, 255, 255, 0.1); }

.codeHint {
  font-family: var(--sans);
  font-weight: 600;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
}
